import {
  ExIcon,
} from '@boomi/exosphere';
import './DisplayProfilePicture.scss';
import { useEffect, useState, useRef } from 'react';

export default function DisplayProfilePicture({
  selectedColor,
  selectedAvatar,
  iconSize,
  showCircular,
  profilePictureStyle,
  useInlineStyle,
}: any) {
  const [currentIcon, setCurrentIcon] = useState('Profile');
  const [iconBgClass, setIconBgClass] = useState('icon-sunset');
  const containerRef = useRef<HTMLDivElement>(null);
  let iconClass = '';
  if (iconSize === 'L') {
    iconClass = 'display-icon-large';
  }
  if (iconSize === 'M') {
    iconClass = 'display-icon-medium';
  }
  if (iconSize === 'S') {
    iconClass = 'display-icon-small';
  }
  if (iconSize === 'SM') {
    iconClass = 'display-icon-small-medium';
  }
  const getIconForAvatar = (avatar: string) => {
    switch (avatar) {
      case 'Default':
        return 'Profile';
      case 'Support':
        return 'Headset';
      case 'Marketplace':
        return 'Market place';
      case 'Data':
        return 'database';
      case 'Automation':
        return 'Treestructure';
      case 'Test':
        return 'Lab';
      case 'Code':
        return 'Players';
      case 'Security':
        return 'Security warning';
      case 'Document':
        return 'Files';
      case 'Analysis':
        return 'Line graph';
      case 'Calendar':
        return 'Calendar';
      case 'Company':
        return 'Company';
      case 'Rocket':
        return 'Rocket';
      case 'Chat':
        return 'Chatcircletext';
      case 'Explore':
        return 'Binoculars';
      default:
        return 'Profile';
    }
  };

  const getBackgroundForColor = (color: string) => {
    switch (color) {
      case 'Sunset':
        return 'icon-sunset';
      case 'Lavender':
        return 'icon-lavender';
      case 'Seabreeze':
        return 'icon-seabreeze';
      case 'Midnight':
        return 'icon-midnight';
      default:
        return 'icon-sunset'; // Fallback theme
    }
  };
  useEffect(() => {
    const newIcon = getIconForAvatar(selectedAvatar);
    setCurrentIcon(newIcon);
  }, [selectedAvatar]);

  useEffect(() => {
    const newThemeClass = getBackgroundForColor(selectedColor);
    setIconBgClass(newThemeClass);
  }, [selectedColor]);

  useEffect(() => {
    if (useInlineStyle && profilePictureStyle && containerRef.current) {
      // Find the parent container (AG Grid cell or similar)
      const parentContainer = containerRef.current.closest('.ag-cell') || containerRef.current.parentElement;
      if (parentContainer) {
        // Create unique ID for this component instance
        const styleId = `profile-picture-override-${Math.random().toString(36).substr(2, 9)}`;
        const style = document.createElement('style');
        style.id = styleId;
        style.innerHTML = profilePictureStyle;
        // Inject style into the parent container (closer to shadow DOM boundary)
        parentContainer.appendChild(style);
        // Cleanup function to remove style when component unmounts
        return () => {
          const existingStyle = parentContainer.querySelector(`#${styleId}`);
          if (existingStyle) {
            existingStyle.remove();
          }
        };
      }
    }
    return () => {};
  }, [useInlineStyle, profilePictureStyle]);

  return (
    <div
      ref={containerRef}
      className={`display-icon-container ${iconBgClass} ${showCircular ? 'circular' : ''} ${iconSize === 'S' && !showCircular ? 'border-radius-4' : ''}`}
    >
      <ExIcon
        icon={currentIcon}
        hide-browser-tooltip=""
        className={iconClass}
      />
    </div>
  );
}
